import { MutableRefObject, useEffect, useRef, useState } from "react";

/**
 * Hook para obtener el ancho de un elemento.
 * @returns {Array} Un array con una referencia al elemento y el ancho del mismo.
 */
export const useElementWidth = (): [MutableRefObject<any>, number] => {
  const elementRef = useRef<HTMLElement | null>(null);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    const handleResize = () => {
      if (elementRef.current) {
        const { width } = elementRef.current.getBoundingClientRect();
        setWidth(width);
      }
    };

    window.addEventListener('resize', handleResize);

    // Llama a handleResize para establecer el ancho inicial
    handleResize();

    // Limpia el listener cuando el componente se desmonta
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return [elementRef, width];
};